import { cached } from '@glimmer/tracking';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesConversationDetailsHandler extends MessagingRoutesBaseHandler {
  @service('spds/toast') toast;
  @service clientProfileNavigator;
  @service intl;
  @service messaging;

  get conversation() {
    return this.options.parentHandler.conversation;
  }

  get isDraft() {
    return this.conversation.isDraft;
  }

  @cached
  get members() {
    return this.conversation.currentMembers(this.messaging.currentProfile?.user);
  }

  @cached
  get previousMembers() {
    return this.conversation.previousMembers(this.messaging.currentProfile?.user);
  }

  get hasPreviousMembers() {
    return this.conversation.hasPreviousMembers;
  }

  canNavigateToClientProfile(member) {
    if (!member.isClient) {
      return false;
    }

    return this.clientProfileNavigator.canNavigateToClientProfile(
      [member],
      this.messaging.currentProfile.isClinician
    );
  }

  navigateToClientProfile = task({ drop: true }, async member => {
    try {
      await this.clientProfileNavigator.navigateToClientProfile(this.conversation, [member]);
    } catch (error) {
      this.toast.error(this.intl.t('emc.general_error'));
    }
  });
}
